// Shared helpers for the lawyer portal's mobile status surfaces (header, drawer, dashboard card).
export const fmtIst = (iso) =>
  new Date(iso).toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata" }).toUpperCase();

export const fmtIstDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata" });

// "14:30" (IST slot_time) → "2:30 PM"
export function fmtSlotTime(hhmm) {
  if (!hhmm) return "—";
  const [h, m] = hhmm.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${ampm}`;
}

export const slotDate = (c) => (c?.slot_date && c?.slot_time ? new Date(`${c.slot_date}T${c.slot_time}:00+05:30`) : null);

export function fmtCountdown(sec) {
  const s = Math.max(0, Math.floor(sec));
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

// Compact "dot + label" description of the engine state, used by the drawer and status card.
export function describeState(state, availability) {
  switch (state) {
    case "online_scheduled":
      return { dot: "bg-emerald-400", tone: "emerald", label: "ONLINE · Scheduled",
        detail: availability?.scheduled_until ? `Available today until ${fmtIst(availability.scheduled_until)}` : "Inside your scheduled hours" };
    case "online_manual":
      return { dot: "bg-emerald-400", tone: "emerald", label: "ONLINE · Manual",
        detail: availability?.manual_online_until ? `Online until ${fmtIst(availability.manual_online_until)} · activity extends it` : "Accepting instant consultations" };
    case "busy":
      return { dot: "bg-rose-500", tone: "rose", label: "IN CONSULTATION", detail: "No new instant consults until this one ends" };
    case "vacation":
      return { dot: "bg-amber-400", tone: "amber", label: "ON VACATION", detail: null };
    default:
      return { dot: "bg-slate-400", tone: "slate", label: "OFFLINE", detail: null };
  }
}
